// src/configs/apiBase.js
// Works for both CRA and Vite, with sensible fallbacks.

const fromVite =
  typeof import.meta !== 'undefined'
    ? import.meta.env?.VITE_API_BASE
    : undefined;

const fromCRA =
  typeof process !== 'undefined'
    ? process.env?.REACT_APP_API_BASE
    : undefined;

const guessByHost = () => {
  const h = window?.location?.hostname;

  // FE local: localhost:3002
  // BE local: localhost:3001
  if (h === 'localhost' || h === '127.0.0.1') {
    return 'https://api.bagspa.belleandkate.com';
  }

  // fallback sementara
  return 'https://api.bagspa.belleandkate.com';
};

export const API_BASE = fromVite || fromCRA || guessByHost();